import { CanDeactivateFn } from '@angular/router';

export const unsavedActionItemFormGuard: CanDeactivateFn<{ confirmLeave(nextUrl: string): Promise<boolean> }> = (
  component,
  _currentRoute,
  _currentState,
  nextState
) => component.confirmLeave(nextState?.url ?? '');
